import { useParams } from 'react-router-dom';

import { SubsetFact } from '../../../../../../../../../../backend/src/types/types';
import { FactDropdown } from '@/new/components/fact/fact-accordion';
import { Icon } from '@/new/components/icon';
import { Accordion } from '@/new/components/shadcn/accordion';
import { Empty, EmptyHeader, EmptyMedia, EmptyTitle, EmptyDescription } from '@/new/components/shadcn/empty';

interface FactEditorTableProps {
  facts: SubsetFact[];
  selectedFactId: string;
  openDocViewer: (docId: string, factId: string, pageNumber: number) => void;
  selectedFactIds: Set<string>;
  onFactSelectionChange: (factId: string, selected: boolean) => void;
}

interface FactRowProps {
  fact: SubsetFact;
  selectedFactId: string;
  openDocViewer: (docId: string, factId: string, pageNumber: number) => void;
  isSelected: boolean;
  onToggle: (factId: string, selected: boolean) => void;
  onFactSelectionChange: (factId: string, selected: boolean) => void;
}

function FactRow({ fact, selectedFactId, openDocViewer, isSelected, onToggle, onFactSelectionChange }: FactRowProps) {
  const { subsetId } = useParams();
  if (!subsetId) return null;

  return (
    <FactDropdown
      fact={fact}
      onViewDocument={openDocViewer}
      selectable={{ isSelected, handleSelect: (v) => onToggle(fact.id, Boolean(v)) }}
      isSelected={selectedFactId === fact.id}
      subsetId={subsetId}
      onFactSelectionChange={onFactSelectionChange}
    />
  );
}

export const FactsTable = ({
  facts,
  selectedFactId,
  openDocViewer,
  selectedFactIds,
  onFactSelectionChange,
}: FactEditorTableProps) => {
  const { matterId, subsetId } = useParams();

  if (!matterId || !subsetId) {
    return;
  }

  return (
    <div className="h-full">
      {facts.length === 0 ? (
        <div className="flex w-full items-center justify-center py-6">
          <Empty>
            <EmptyHeader>
              <EmptyMedia variant="icon">
                <Icon className="lucide--search h-5 w-5" />
              </EmptyMedia>
              <EmptyTitle>No facts found</EmptyTitle>
              <EmptyDescription>Sorry, we couldn't find any facts matching these criteria.</EmptyDescription>
            </EmptyHeader>
          </Empty>
        </div>
      ) : (
        <Accordion type="multiple" className="mx-5 flex flex-col overflow-auto">
          {facts.map((fact) => (
            <FactRow
              key={fact.id}
              fact={fact}
              selectedFactId={selectedFactId}
              openDocViewer={openDocViewer}
              isSelected={selectedFactIds.has(fact.id)}
              onToggle={onFactSelectionChange}
              onFactSelectionChange={onFactSelectionChange}
            />
          ))}
        </Accordion>
      )}
    </div>
  );
};
